import api from './api';
import { Category, CategoryFormData, ApiResponse } from '../types';

export const categoryService = {
  async getAll(ativoOnly?: boolean): Promise<Category[]> {
    const response = await api.get<Category[]>('/categories', {
      params: ativoOnly ? { ativo: 1 } : undefined,
    });
    return response.data;
  },

  async create(data: CategoryFormData): Promise<ApiResponse<Category>> {
    const response = await api.post<ApiResponse<Category>>('/categories', data);
    return response.data;
  },

  async update(id: number, data: CategoryFormData): Promise<ApiResponse<Category>> {
    const response = await api.put<ApiResponse<Category>>(`/categories/${id}`, data);
    return response.data;
  },

  async toggleActive(id: number): Promise<ApiResponse<Category>> {
    const response = await api.patch<ApiResponse<Category>>(`/categories/${id}/toggle-active`);
    return response.data;
  },

  async delete(id: number): Promise<ApiResponse<void>> {
    const response = await api.delete<ApiResponse<void>>(`/categories/${id}`);
    return response.data;
  },
};
